(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/onboarding/slides/assets/javascripts/animations/composers/keep-composer.js') >= 0) return;  svs.modules.push('/components/onboarding/slides/assets/javascripts/animations/composers/keep-composer.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const keepComposerAsync = (slidesList, slideInTween, slideOutTween, resetTween) => new Promise(resolve => {
  if (!slidesList || slidesList.length < 2) {
    throw new Error('slideList must contain atleast 2 elements');
  }
  const duration = 0.75; 
  const tl = gsap.timeline();
  const _slidesList = _slicedToArray(slidesList, 2),
    outEl = _slidesList[0],
    inEl = _slidesList[1];
  const inDuration = duration / inEl.length;
  const outDuration = duration / outEl.length;
  outEl.forEach((el, i) => {
    const slotTime = outDuration * i;
    tl.add(slideOutTween(el, outDuration), slotTime);
  });
  inEl.forEach((el, i) => {
    const slotTime = inDuration * i;
    tl.add(resetTween(el, 0));
    tl.add(slideInTween(el, inDuration), slotTime);
  });
  tl.eventCallback('onComplete', () => {
    resolve();
  }).play();
});
setGlobal('svs.components.onboarding.slides.animations.composers.keepComposerAsync', keepComposerAsync);

 })(window);